<template>
  <div id="MusicFiles">
     <v-container class="pa-0">
      <v-layout>
        <v-flex class="xs12 sm12" style="min-height:70px;">
          <v-btn fab absolute to="dashboard" left class="ml-3 pf-btn-fab">
            <v-icon>arrow_back</v-icon>
          </v-btn>
          <v-btn fab absolute right to="music/add" class="mr-3 pf-btn-fab">
            <v-icon>add</v-icon>
          </v-btn>
        </v-flex>
      </v-layout>
    </v-container>
    <v-container>
      <v-layout row wrap class="pb-4 xs12 text-xs-center" v-if="Music.length">
        <template v-for="(audio, i) in Music">
          <v-flex v-if="audio.file" :key="i" class="pa-1 text-xs-center xs12 sm4">
            <v-card flat tile class="positionrel pf-cursor-pointer border-radius-25 flex-column-center pa-2">
              <audio controls>
                <source :src="`${ config.uploadPath }${ audio.file.webPath }`" :type="audio.file.mimetype">
                Your browser does not support the audio element.
              </audio>
              <v-flex class="d-flex align-center">
                <v-edit-dialog
                  :return-value.sync="audio.name"
                  lazy
                  :large="audio.name ? true : false"
                  @save="nameUpdate(audio, i)"
                > {{ audio.name ? audio.name : 'Untitled' }}
                  <template v-slot:input>
                    <v-text-field
                      :rules="fileNameRules"
                      v-model.trim="audio.name"
                      label="Music Name"
                      single-line
                      class="pf-menu-text"
                    ></v-text-field>
                  </template>
                </v-edit-dialog>
                <v-btn icon class="mt-1 mb-1" title="Delete" v-on:click="deleteItem(audio, i);">
                  <v-icon size="22" color="red">delete_outline</v-icon>
                </v-btn>
              </v-flex>
            </v-card>
          </v-flex>
        </template>
      </v-layout>
      <v-layout v-else row wrap class="pa-4 xs12 text-xs-center">
        <v-flex>
          <p class="mb-0">No music files found</p>
        </v-flex>        
      </v-layout>
    </v-container>
  </div>
</template>
<script>
/* global session store config */  
import UploadButton from 'vuetify-upload-button';
import swal from 'sweetalert2';
import Sortable, { MultiDrag, Swap } from 'sortablejs';
import { create, getCollection, remove, uploadFile, formatDate, update } from '../../helpers/helpers';
import Vue from 'vue';

export default {
  components: {
    'upload-btn': UploadButton,
  },
  data: () => ({
    entity: 'Music',
    search: '',
    config: config,
    selectedData: false,
    fileNameRules: [
      v => !!v || 'File name is required'
    ]
  }),
  beforeRouteEnter (to, from, next) {
    if (!session.isOnline()) {
      next({ path: '/login' });
    } else {
      next();
    }
  },
  computed: {
    Music: {
      get () {
        return store.state.Music;
      },
      set (value) {
        store.commit('setMusic', value);
      }
    }
  },
  created () {
    this.getMusic();
  },
  methods: {
    async nameUpdate (item, index) {
      let itemClone = { ...item };
      let { error, data, status } = await update(this.entity, itemClone, itemClone.id);
      if (error) {
        this.selectedData = true;
        console.log('error', error);
      } else {
        this.Music[index] = data;
        swal.fire({
          type: 'success',
          title: 'Music name updated successfully',
          showConfirmButton: false,
          timer: 2500,
          onClose: () => {
            //
          }
        });
      }
    },
    async getMusic () {
      if (!this.Music.length) {
        let sort = { sort_no: 1 };
        let { error, data } = await getCollection(this.entity, true, 0, '', {}, null, null, sort);
        if (error) {
          console.log(error);
        } else {
          if (data.length > 0) {
            this.Music = data;
          }
        }
      }
    },
    deleteItem (item, index) {
      swal.fire({
        title: 'Are you sure?',
        text: "You won't be able to revert this!",
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, delete it!'
      }).then((result) => {
        if (result.value) {
          (async () => {
            let { error, data, status } = await remove(this.entity, item.id);
            if (error) {
              console.log('error', error);
            } else {
              this.Music.splice(index, 1);
              swal.fire(
                'Deleted!',
                'The file "' + item.name + '" has been deleted.',
                'success'
              );
            }
          })();
        }
      });
    }
  }
};
</script>
<style scoped style="css">
.custom-mt {
  margin-top: 6px;
}
#MusicFiles >>> .v-small-dialog__content {
  width:  350px !important;
  padding: 0;
}
.v-menu__content {
  width: 400px !important;
}
#MusicFiles >>> .upload-btn {
  border-radius: 50%;
  min-width: 0;
  height: 56px;
  width: 56px !important;
  padding: 0;
}
#MusicFiles >>> .v-btn--icon.upload-btn {
  background-color: #7ac142 !important;
  margin: 0;
}
</style>



// WEBPACK FOOTER //
// src/pages/Music/list.vue